import type { ChatMessageCollectAttachItem } from "@digital-twins/shared-types";
import type { TFunction } from "i18next";

/**
 * An attach card's question (F19), in the interface language, from its typed
 * items: the server sends the items and no words, so the builder's copy is
 * the one owner of how the card asks.
 */
export function attachCardQuestion(
  items: ReadonlyArray<ChatMessageCollectAttachItem>,
  t: TFunction<"app">,
): string {
  if (items.length === 0) return "";
  if (items.length === 1) {
    return t("questionnaire.attachCard.askOne", { item: items[0].label });
  }
  return t("questionnaire.attachCard.askMany", {
    items: items.map((item) => `"${item.label}"`).join(", "),
  });
}
